// import i18n from "@martyrs/src/modules/core/views/localization/vue-i18n.js";
// Валидаторы возвращают КЛЮЧ сообщения (auth.validation.* в локалях модуля),
// а не текст: у этого файла нет i18n, текст на языке страницы печатает Field
// ($te/$t). Объект messages с текстами здесь был мёртвым — ключи validation.*
// не были зарегистрированы ни в одной локали, и под полем печатался сырой ключ.

// i18n.global.mergeLocaleMessage('ru', messages.ru);
// i18n.global.mergeLocaleMessage('en', messages.en);

function validateLength(input) {
  const length = input.length;

  if (length < 1) {
    return {
      status: false,
      // message:  i18n.global.t("validation.length")
      message: 'auth.validation.length',
    };
  }

  return {
    status: true,
    message: null,
  };
}

function validatePhone(phone) {
  return {
    status: true,
    message: null,
  };
}

function validateEmail(email) {
  // const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,12}$/; Not allowing to add +1, +2, +3 and etc after email
  const emailRegex = /^[\w-]+(\.[\w-]+)*(\+[\w-]+)?@([\w-]+\.)+[\w-]{2,12}$/;

  if (!emailRegex.test(email)) {
    return {
      status: false,
      // message:  i18n.global.t("validation.email")
      message: 'auth.validation.emailFormat',
    };
  }

  return {
    status: true,
    message: null,
  };
}

function validatePassword(password) {
  const lowercaseRegex = /[a-z]/;
  const uppercaseRegex = /[A-Z]/;
  const numberRegex = /[0-9]/;
  const specialCharRegex = /[@$!%*?&]/;

  if (password.length < 8) {
    return {
      status: false,
      // message:  i18n.global.t("validation.password.minLength")
      message: 'auth.validation.passwordLength',
    };
  }

  // if (!lowercaseRegex.test(password)) {
  //    return {
  //     status: false,
  //     message:i18n.global.t("validation.password.lowercase")
  //   }
  // }

  // if (!uppercaseRegex.test(password)) {
  //   return {
  //     status: false,
  //     message: i18n.global.t("validation.password.uppercase")
  //   }
  // }

  // if (!numberRegex.test(password)) {
  //   return {
  //     status: false,
  //     message: i18n.global.t("validation.password.number")
  //   }
  // }

  // if (!specialCharRegex.test(password)) {
  //   return {
  //     status: false,
  //     message: i18n.global.t("validation.password.specialChar")
  //   }
  // }

  return {
    status: true,
    message: null,
  };
}

async function validateInputs(input, method, variable, message) {
  if (!variable) {
    input.value = {
      status: false,
      // message: i18n.global.t("validation.length")
      message: 'auth.validation.length',
    };

    setTimeout(() => {
      input.value = null;
    }, 3000);
    // throw new Error(i18n.global.t("validation.length"));
    throw new Error('auth.validation.length');
  } else {
    const InputGood = method(variable);

    if (!InputGood.status) {
      input.value = InputGood;
      setTimeout(() => {
        input.value = null;
      }, 3000);
      throw new Error(message);
    }
  }
}

export { validateEmail, validateInputs, validateLength, validatePassword, validatePhone };
